<template>
  <div style="position: relative;">
    <div>
      <div class="d-flex justify-content-between" style="margin-bottom: 1.70rem;">
        <div class="d-flex align-items-center" style="gap: 2.34rem;">
          <!-- <div>
            <h1 class="title">{{ $t("audit-control.control.organization") }}</h1>
          </div> -->
          <div class="search2">
            <div class="search2--icon"><i class="iconoir-search"></i></div>
            <input v-model="nameFilter" class="search2--input" type="text" :placeholder="$t('common.search')" />
          </div>
        </div>

        <div class="d-flex align-items-center float-right ml-4">
          <div class="d-flex align-items-center" style="cursor: pointer;" @click="toggleRightPanel">
            <div class="new-task-text">{{ $t("audit-control.control.new") }}</div>
            <div class="plus-button" style="margin-right: 1.56rem;"></div>
          </div>
        </div>
      </div>
      <div>
        <right-panel id="sidebar-new-control" width="1050px" @hidden="rightPanelClosed" :text="$t('audit-control.control.new')">
          <div class="pl-5 pr-5">
            <OrganizationControlForm
              :hide-library="true"
              :closeOnSave="false"
              @onSave="paginate"
              ref="OrganizationControlForm"
              :allowedClass="allowedClass"
              :lockedClass="lockedClass"
            />
          </div>
        </right-panel>
      </div>

      <nav class="tab-menu">
        <div
          :class="{ active: activeTab === 'ORGANIZATION_CONTROLS' }"
          @click="
            activeTab = 'ORGANIZATION_CONTROLS';
            if (!activeSubTab) activeSubTab = 'ACTIVE';
          "
        >
          {{ $t("audit-control.control.organization") }}
        </div>

        <div :class="{ active: activeTab === 'MY_APPROVALS' }" @click="activeTab = 'MY_APPROVALS'">{{ $t("audit-control.status.tab-my-approvals") }}</div>
      </nav>

      <div class="mt-4">
        <div>
          <!-- Sub-tabs for Organization Controls -->
          <div class="mb-4" v-if="activeTab === 'ORGANIZATION_CONTROLS'">
            <nav class="tab-menu">
              <div :class="{ active: activeSubTab === 'EVALUATION_PENDING' }" @click="activeSubTab = 'EVALUATION_PENDING'">
                {{ $t("audit-control.status.tab-evaluation-pending") }}
              </div>
              <div :class="{ active: activeSubTab === 'ACTIVE' }" @click="activeSubTab = 'ACTIVE'">
                {{ $t("audit-control.status.tab-active-ongoing") }}
              </div>
              <div :class="{ active: activeSubTab === 'COMPLETED' }" @click="activeSubTab = 'COMPLETED'">
                {{ $t("audit-control.status.tab-completed") }}
              </div>
              <div :class="{ active: activeSubTab === 'PASSIVE' }" @click="activeSubTab = 'PASSIVE'">
                {{ $t("audit-control.status.tab-passive") }}
              </div>
              <div :class="{ active: activeSubTab === 'ALL' }" @click="activeSubTab = 'ALL'">
                {{ $t("audit-control.list.all") }}
              </div>
            </nav>
          </div>

          <div class="d-flex flex-column">
            <div class="d-flex justify-content-end mb-3">
              <b-button variant="light" size="sm" class="text-info font-weight-bold" @click="showFilters = !showFilters">
                <i class="bx bx-filter"></i> {{ $t("common.filter") }}
              </b-button>
            </div>

            <div class="d-flex">
              <div v-if="showFilters" class="mr-3 border-right pr-3" style="width: 320px; flex-shrink: 0;">
                <AuditControlFilterSidebar />
              </div>
              <div class="flex-grow-1" style="min-width: 0;">
                <content-loading v-if="isLoading" />
                <div v-else>
                  <div v-if="activeStatus != 'ALL'">
                    <div v-if="pagination && pagination.docs" class="row">
                      <div :class="showFilters ? 'col-md-6 mb-4' : 'col-md-4 mb-4'" v-for="control in pagination.docs" :key="control._id">
                        <OrganizationControlCard :control="control" @edit="edit" />
                      </div>
                    </div>
                  </div>
                  <OrganizationControlList v-else :pagination="pagination" :isLoading="isLoading" @edit="edit" @delete="deleteById" />
                </div>
              </div>
            </div>
          </div>

          <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
            <h5 class="text-center">
              {{ $t("common.no-data") }}
            </h5>
          </empty>

          <div v-if="pagination && pagination.docs.length > 0" class="row mt-4">
            <div class="col">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationControlForm from "./organization-control-form.vue";
import OrganizationControlCard from "./organization-control-card.vue";
import OrganizationControlList from "./organization-control-list.vue";
import AuditControlFilterSidebar from "../audit/audit-control-filter-sidebar.vue";

export default {
  components: { OrganizationControlForm, OrganizationControlCard, OrganizationControlList, AuditControlFilterSidebar },
  props: {
    allowedClass: {
      type: String,
      default: undefined,
    },
    lockedClass: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nameFilter: undefined,
      noFilter: undefined,
      request: {
        options: { page: 1, limit: 15, sort: { createdAt: "desc" } },
        query: {
          status: {
            value: { $in: ["ACTIVE", "EDIT_REQUESTED_EVALUATING", "REJECTED_EVALUATING"] },
            isObject: true,
          },
        },
      },
    };
  },
  created() {
    if (this.allowedClass) {
      this.request.query.class = { value: this.allowedClass, isObject: true };
    }
  },

  computed: {
    activeTab: {
      get() {
        return this.$store.getters["organizationControl/activeTab"];
      },
      set(v) {
        this.$store.commit("organizationControl/activeTab", v);
      },
    },
    activeSubTab: {
      get() {
        return this.$store.getters["organizationControl/activeSubTab"];
      },
      set(v) {
        this.$store.commit("organizationControl/activeSubTab", v);
      },
    },
    showFilters: {
      get() {
        return this.$store.getters["organizationControl/showFilterSidebar"];
      },
      set(v) {
        this.$store.commit("organizationControl/showFilterSidebar", v);
      },
    },
    pagination() {
      return this.$store.getters["organizationControl/pagination"];
    },
    currentAccount() {
      return this.$store.getters["user/account"];
    },
    isLoading() {
      return this.$store.getters["organizationControl/isLoading"];
    },
    controlFilters() {
      return this.$store.getters["organizationControl/controlFilters"] || {};
    },
    activeStatus() {
      if (this.activeTab === "MY_APPROVALS") {
        return "MY_APPROVALS";
      }
      return this.activeSubTab;
    },
  },

  mounted() {
    this.updateQuery();
  },
  watch: {
    nameFilter(n) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        delete this.request.query["name"];
      }
      this.request.options.page = 1;
      this.debounceMixin(() => this.paginate());
    },
    noFilter(n) {
      if (n) {
        this.request.query = { ...this.request.query, no: { value: n, isObject: true } };
      } else {
        delete this.request.query["no"];
      }
      this.request.options.page = 1;
      this.debounceMixin(() => this.paginate());
    },
    activeTab() {
      this.updateQuery();
    },
    activeSubTab() {
      this.updateQuery();
    },
    controlFilters: {
      deep: true,
      handler() {
        this.request.options.page = 1;
        this.debounceMixin(() => this.paginate());
      },
    },
    request: {
      deep: true,
      handler() {
        this.debounceMixin(() => this.paginate());
      },
    },
    allowedClass: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.request.query.class = { value: newValue, isObject: true };
        } else {
          delete this.request.query.class;
        }
        this.paginate();
      },
    },
  },
  methods: {
    updateQuery() {
      const newQuery = { ...this.request.query };

      // Clean up previous status/approval filters
      delete newQuery.status;
      delete newQuery["approvals.0.assignee._id"];
      delete newQuery["approvals.0.status"];

      if (this.activeTab === "MY_APPROVALS") {
        if (this.currentAccount) {
          newQuery["approvals.0.assignee._id"] = { value: this.currentAccount._id, isObject: true };
          newQuery["approvals.0.status"] = { value: "PENDING", isObject: true };
        }
      } else {
        // Organization Controls Tab (using sub-tabs)
        switch (this.activeSubTab) {
          case "EVALUATION_PENDING":
            newQuery.status = {
              value: { $in: ["EDIT_REQUESTED_EVALUATING", "REJECTED_EVALUATING"] },
              isObject: true,
            };
            break;
          case "ACTIVE":
            newQuery.status = { value: "ACTIVE", isObject: true };
            break;
          case "COMPLETED":
            newQuery.status = { value: "COMPLETED", isObject: true };
            break;
          case "PASSIVE":
            newQuery.status = { value: "PASSIVE", isObject: true };
            break;
          case "ALL":
            // No status filter
            break;
        }
      }

      this.request.query = newQuery;
      this.request.options.page = 1;
    },
    displayDefinitions(array) {
      if (!array || !array.length) {
        return "";
      }
      return array.map((i) => i.name[this.currentLanguage]).join(", ");
    },
    toggleRightPanel() {
      this.$store.commit("organizationControl/editedEntity", undefined);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-control");
    },
    rightPanelClosed() {
      this.$store.commit("organizationControl/editedEntity", undefined);
    },
    async paginate() {
      this.$store.commit("organizationControl/isLoading", true);
      try {
        const response = await this.$store.dispatch("organizationControl/fetchFilteredControls", { query: this.request.query, options: this.request.options });
        this.$store.commit("organizationControl/pagination", response.data);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.$store.commit("organizationControl/isLoading", false);
      }
    },
    edit(control) {
      this.$store.commit("organizationControl/editedEntity", control);

      // Determine the navigation path based on current route or disallowed class
      // If we are on a specific route like /audit-control/compliance, we should stay on it.
      // But simpler is to check current route path prefix
      let basePath = "/audit-control/control";
      if (this.$route.path.includes("/audit-control/compliance")) {
        basePath = "/audit-control/compliance";
      } else if (this.$route.path.includes("/audit-control/audit")) {
        basePath = "/audit-control/audit";
      }

      this.$router.push(`${basePath}/detail/${control._id}`);
    },
    async deleteById(id) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationControl/delete`, id);
        this.paginate();
        this.$toast.success(this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@modules/core/compliance-item/organization-policy.scss";
</style>
